import React from 'react'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'
import {
  ApplicableLabel,
  ApplicableLabels,
  ApplicablePanel,
  ApplicableValue,
} from './styled'

export const NormativeApplicableInfo: React.FC = () => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.trainingType.normative`,
  })

  return (
    <ApplicablePanel>
      <ApplicableLabels>
        <ApplicableLabel>{t('applicableLabel')}</ApplicableLabel>
        <ApplicableValue>{t('certificate')}</ApplicableValue>
      </ApplicableLabels>
    </ApplicablePanel>
  )
}
